export const FOOTER_HEIGHT = '266px';

export const MAX_PAGE_WIDTH = '1280px';

export const FULL_PAGE_HEIGHT = `calc(100vh - ${FOOTER_HEIGHT});`;
